import user from './user';
import release from './release';
import project from './project';
import environment from './environment';
import role from './role';

export default {
  user,
  release,
  project,
  environment,
  role,
};
